import type { ReactNode } from "react";
import { type TextAlignment, textAlignments, tw } from "../../styling";

type Element = "p" | "span" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "caption";

type Props<T extends React.ElementType> = {
	children: ReactNode;
	component?: T;
	align?: TextAlignment;
	bold?: boolean;
	italic?: boolean;
} & Omit<React.ComponentPropsWithoutRef<T>, "color">;

export const Text = <T extends React.ElementType<any, Element> = "span">({
	component,
	children,
	align,
	bold,
	italic,
	className,

	...rest
}: Props<T>) => {
	const Component = component || "span";

	return (
		<Component
			// todo: quick fix to use twJoin instead of merge
			className={tw(
				"text-base",
				"text-text-primary",
				bold && "font-bold",
				italic && "italic",
				align && textAlignments[align],
				className,
			)}
			{...rest}
		>
			{children}
		</Component>
	);
};
